import React from "react";
import PropTypes from "prop-types";
import Text from "@shared/components/Text";
import styled from "@emotion/styled";
import PlanBadge from "@ats/src/components/shared/PlanBadge";

export default function FormSection(props) {
  const {
    id,
    title,
    intro,
    children,
    planKey,
    planDisplayName,
    locked,
    badgeSize = "small",
  } = props;
  return (
    <Styled.Container>
      {title !== undefined && (
        <Styled.Intro id={id}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <Text as="h4" size="md" weight="bold">
              {title}
            </Text>
            {planKey && planDisplayName && (
              <PlanBadge
                planKey={planKey}
                planDisplayName={planDisplayName}
                locked={locked}
                size={badgeSize}
                includeUrl={true}
              />
            )}
          </span>
          {intro ? <p>{intro}</p> : null}
        </Styled.Intro>
      )}
      {children}
    </Styled.Container>
  );
}

FormSection.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  intro: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};

FormSection.defaultProps = {};

/* Styled Components
======================================================= */
const Styled = {};

Styled.Container = styled.div`
  margin-top: 24px;
  margin-bottom: 32px;
`;

Styled.Intro = styled.div`
  margin-bottom: 16px;
  color: ${(props) => props.theme.poly.color.primaryText};
  p {
    margin-top: 8px;
    color: ${(props) => props.theme.poly.color.secondaryText};
  }
`;
